import React from 'react';
import './Settings.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';

export default function Settings(props) {
      return (
      <div className="settings">
       <div id="break" className="setting">
              <div className="up-container">
                <FontAwesomeIcon id="break-increment" className="up" icon={faArrowCircleUp} onClick={props.status ? null : props.chrono[0] === props.sessionLength ? props.changeBreakUp : props.reset } />
              </div>
              <div className="break-container">
                <div id="break-label" className="break-label"> Break </div>
                <div id="break-length" className="break-text">{`${props.breakLength}:00`}</div>
              </div>
              <div className="down-container">
                <FontAwesomeIcon id="break-decrement" className="down" icon={faArrowCircleDown} onClick={props.status ? null : props.chrono[0] === props.sessionLength ? props.changeBreakDown : props.reset} />
              </div> 
        </div>
         <div id="session-length" className="setting">
              <div className="up-container">
                <FontAwesomeIcon id="session-increment" className="up" icon={faArrowCircleUp} onClick={props.status ? null : props.chrono[0] === props.sessionLength ? props.changeLengthUp : props.reset } />
              </div>
              <div className="session-container">
                <div id="session-label" className="session-label"> Session </div>
                <div id="session-length" className="session-length-text">{`${props.sessionLength}:00`}</div>
              </div>
              <div className="down-container">
                <FontAwesomeIcon id="session-decrement" className="down" icon={faArrowCircleDown} onClick={props.status ? null : props.chrono[0] === props.sessionLength ? props.changeLengthDown : props.reset} />
              </div> 
        </div>
      </div>
    )
  }

